// src/features/engine/components/ProjectIntro.jsx

import { useProgramEngine } from "../../engine/context/ProgramEngineContext";
import { useTranslation } from "react-i18next";
import UIBlock from "./UIBlock";

export default function ProjectIntro() {

  const { t } = useTranslation();

  const {
    program,
    project,
    attempt,
    startProgram
  } = useProgramEngine();

  const steps = program?.steps || [];

  const completedSteps =
    attempt?.steps?.filter(s => s.completed).map(s => s.stepKey) || [];

  const resolveText = (key, fallback = "") => {
    if (!key) return fallback;
    const translated = t(key);
    return (!translated || translated === key) ? fallback : translated;
  };

  const uiMessages = project?.uiMessages || {};
  const uiBlocks = project?.uiBlocks || {};

  return (

    <div style={{ padding: 24, maxWidth: 720, margin: "0 auto" }}>

      <h1>
        {resolveText(project?.titleKey, project?.title)}
      </h1>

      {uiMessages.introMessageKey && (
        <p style={{ marginTop: 16 }}>
          {t(uiMessages.introMessageKey)}
        </p>
      )}

      {uiBlocks?.ethics && (
        <UIBlock
          title={t(uiBlocks.ethics.titleKey)}
          text={t(uiBlocks.ethics.textKey)}
          variant="info"
        />
      )}

      <div style={{ marginTop: 24 }}>

        {steps.map(step => {

          const isCompleted =
            completedSteps.includes(step.key);

          return (
            <div key={step.key} style={{ padding: 12, marginBottom: 8, border: "1px solid #ddd" }}>
              <strong>{resolveText(step.titleKey, step.key)}</strong>
              <div style={{ fontSize: 12 }}>
                {isCompleted ? "✅ Completed" : "▶️ Available"}
              </div>
            </div>
          );

        })}

      </div>

      <button onClick={startProgram} style={{ marginTop: 32 }}>
        {uiMessages.introButtonKey ? t(uiMessages.introButtonKey) : "Start"}
      </button>

    </div>
  );
}